// Updated ApiEndPoints.js
export const ApiEndPoints = {
  LOGIN_API_CALL: "auth/signin",
  CHANGE_PASSWORD: "auth/change-password",
  GET_ADMIN_USERS: "auth/get-admin",
  SIGNUP_API_CALL: "auth/signup",
  UPDATE_BOOKING_STATUS: "bookings",

  GET_ROLES: "role/roles",
  CREATE_ROLE: "role/roles",
  UPDATE_ROLE: "role/roles/",
  DELETE_ADMIN: "auth/delete-",
  GET_BIOMARK_FOR_SELECT: "biomarkers/get_biomarkers_for_select",
  GET_BIOMARK_GROUP_FOR_SELECT: "biomarker-groups/get_biomarker_groups_for_select",
  GET_PACKAGES_FOR_SELECT: "packages/get_packages_for_select",
  GET_PACKAGES_CATERGORIES: "package-categories/get_package_categories_for_select",
  DELETE_ROLE: "role/roles/",
  ASSIGN_ROLE: "role/assign-role",
  ASSIGN_PERMISSIONS: "auth/assign-permissions",
  PROFESSION_RESOURCE_ROUTE: "/professions",
  GET_SPECIALITIES_FOR_SELECT: "/specialities/get_specialities_for_select",
  GET_FACILITIES_FOR_SELECT: "/common/get-facilities-for-select",
  GET_LANGUAGES_FOR_SELECT: "/common/get-languages-for-select",
  GET_SERVICES_FOR_SELECT: "/common/get-services-for-select",
  GET_ZONES_FOR_SELECT: "/common/zones-for-select",
  GET_CITIES_FOR_SELECT: "/common/cities-for-select",
  GET_ESTABLISHMENT_FOR_SELECT: "/establishments/get_list_for_select",
  GET_PROFESSIONS_FOR_SELECT: "/professions/get-professions-for-select",
  GET_ESTABLISHMENT_TYPES_FOR_SELECT:
    "/common/get_establishment_types_for_select",
  GET_ESTABLISHMENT_SUB_TYPES_FOR_SELECT:
    "/common/get-sub-establishment-types-for-select",
  CREATE_ESTABLISHMENT_HOURS: "/establishments/manage-working-hours",
  GET_PROFESSION_TYPES_FOR_SELECT:
    "/profession-types/get-profession-types-for-select",
  ESTABLISHMENT_BANNER_IMAGES_ROUTE: "/establishment-banner-images",
  NATIONALITIES_RESOURCE_ROUTE: "/nationalities",
  ZONES_RESOURCE_ROUTE: "/zones",
  CITIES_RESOURCE_ROUTE: "/cities",
  ESTABLISHMENT_RESOURCE_ROUTE: "/establishments",
  ESTABLISHMENT_BULK_UPLOAD_ROUTE: "/establishments/bulk-upload",
  SPECIALITIES_RESOURCE_ROUTE: "/specialities",
  DEPARTMENT_RESOURCE_ROUTE: "/departments",
  CREATE_DEPARTMENT_HOURS: "/departments/manage-working-hours",
  DEPARTMENT_HOURS_RESOURCE_ROUTE: "/department-hours",
  DEPARTMENT_HOLIDAYS_RESOURCE_ROUTE: "/department-holidays",
  ESTABLISHMENT_HOURS_RESOURCE_ROUTE: "/establishment-hours",
  ESTABLISHMENT_HOLIDAYS_RESOURCE_ROUTE: "/establishment-holidays",
  ESTABLISHMENT_IMAGES_ROUTE: "/establishment-images",
  ESTABLISHMENT_TYPES: "/establishment-types",
  ESTABLISHMENT_SUB_TYPES: "/establishment-sub-types",
  FACILITIES: "/facilities",
  PROFESSION_TYPES: "/profession-types",
  BANNERS: "/banners",
  SERVICES: "/services",
  UPDATE_PROFESSION_STATUS: `${process.env.REACT_APP_BASE_URL}professions/update-status`,
  UPDATE_ESTABLISHMENT_STATUS: `${process.env.REACT_APP_BASE_URL}establishments/update-status`,

  FAQS: "/faqs",
  DEMO_LOGIN: "/demo",
  LANGUAGES: "/languages",
  BOOKING: "/bookings",
  BIOMARKERS: `${process.env.REACT_APP_BASE_URL}biomarkers`,
  BIOMARKER_GROUPS: `${process.env.REACT_APP_BASE_URL}biomarker-groups`,
  PACKAGES: "/packages",
  GET_PACKAGE_ADDONS: `${process.env.REACT_APP_BASE_URL}packages/:id/get_addons`,
  PACKAGE_CATEGORIES: `${process.env.REACT_APP_BASE_URL}package-categories`,
  PACKAGE_BOOKINGS: `${process.env.REACT_APP_BASE_URL}package-bookings`,
  GET_PROFESSIONS_BY_ESTABLISHMENT: "/professions/get-professions-establishment-select",

  // Insurance APIs
  INSURANCE_COMPANY_RESOURCE_ROUTE: `${process.env.REACT_APP_BASE_URL}insurance-company`,
  INSURANCE_COMPANY_SELECT: `${process.env.REACT_APP_BASE_URL}insurance-company/select`,
  INSURANCE_NETWORK_RESOURCE_ROUTE: `${process.env.REACT_APP_BASE_URL}insurance-network`,
  INSURANCE_NETWORK_SELECT: `${process.env.REACT_APP_BASE_URL}insurance-network/select`,
  NSURANCE_PLAN_RESOURCE_ROUTE: `${process.env.REACT_APP_BASE_URL}insurance-plans`,
  INSURANCE_PLAN_SELECT: `${process.env.REACT_APP_BASE_URL}insurance-planS/select`,
  INSURANCE_PLAN_BENEFITS_SEARCH: `${process.env.REACT_APP_BASE_URL}insurance-plans/benefits/search`,
  BENEFITS: `${process.env.REACT_APP_BASE_URL}benefits`,
  BENEFITS_SELECT: `${process.env.REACT_APP_BASE_URL}benefits/select`,
  GET_BRANDS_FOR_SELECT: "/common/get-brands-for-select",
  PACKAGE_BUNDLES: "/package-bundles",
  PACKAGES_SELECT: "/packages/select", // id + name list
  INSURANCE_BENEFITS_RESOURCE_ROUTE: "/admin/insurance-plans/benefits",
  PACKAGE_PURCHASE_LIST: "bundle-purchases",
  // Insurance Leads APIs
  INSURANCE_LEADS: "insurance-leads",
  INSURANCE_LEAD_DETAIL: "insurance-leads/",
};